// @flow

const user = (state: any = {}, action: any ) => {
  switch(action.type) {
    case 'AUTH_SET_TOKEN':
      return { ...state, token: action.token }
    case 'LOGIN':
      return { ...action.user }
    case 'LOGIN_ERROR':
      return { ...state, error: action.payload }
    case 'LOGOUT':
      return {};
    case 'USER_RESET_LOADING':
      return Object.assign({}, state, {})
    case 'USER_SET_PERSONAL_INFO':
      return { ...state, primary_phone: action.payload.primary_phone,
                  subscribed_to_newsletter: action.payload.subscribed_to_newsletter, business_name: action.payload.business_name }
    case 'USER_SET_NOTIFICATION':
      return { ...state, [action.payload.type]: action.payload.value }
    case 'USER_SET_SCOPES':
      return { ...state, scopes: action.payload }
    case 'UPDATE_PASSWORD_SUCCESS':
      return { ...state, passwordUpdateStatus: 'ok' }
    case 'UPDATE_PASSWORD_FAILURE':
      return { ...state, passwordUpdateStatus: 'failure' }
    default:
      return state;
  }
}

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js